import styled from 'styled-components'
import { rem } from 'polished'
import { Heading4Style, Heading5Style } from 'LuxKit/Typography/Heading'

const ChatMarkdownWrapper = styled.div`
  && .compact > p + ul,
  && .compact > p + ol {
    margin-block-start: 0;
  }

  && .compact ul,
  && .compact ol {
    margin-inline-start: 0;
    padding-inline-start: ${rem(24)};
  }

  && .compact ul > li,
  && .compact ol > li {
    margin-block-start: ${rem(8)};
    padding-inline-start: ${rem(8)};
    text-indent: 0;
  }

  && .compact ul > li::before {
    inset-inline-start: ${rem(-16)};
    inset-inline-end: auto;
  }

  && h2 {
    ${Heading4Style}
  }
  && h3 {
    ${Heading5Style}
  }

  .place-tag:not(.place-tag--failed),
  && .offer-tag {
    font-weight: ${props => props.theme.font.primary.weight.regular};
    text-decoration: none;
    background-image: radial-gradient(circle, currentcolor ${rem(0.5)}, transparent ${rem(0.65)});
    background-position: 0 calc(100% - ${rem(1)});
    background-repeat: repeat-x;
    background-size: ${rem(3)} ${rem(1)};
  }

  .place-tag--failed {
    background-image: none;
    font-weight: inherit;
    text-decoration: none;
  }

  /* Markdown tables scroll horizontally rather than being clipped, but only once
     they hit the min-width below — until then auto table layout condenses the
     columns to fit, sizing each one to its content. */
  .markdown-table-scroll {
    overflow-x: auto;
    overscroll-behavior-x: contain;
    -webkit-overflow-scrolling: touch;

    table {
      min-width: ${rem(560)};
    }

    th,
    td {
      hyphens: auto;
    }
  }
`

export default ChatMarkdownWrapper
